var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueDownwardArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_159_2832",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_159_2832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "expand_more",
    d: "M12 14.65C11.8833 14.65 11.771 14.6333 11.663 14.6C11.5543 14.5667 11.4583 14.5 11.375 14.4L6.85 9.90001C6.71667 9.75001 6.65 9.57501 6.65 9.37501C6.65 9.17501 6.725 9.00001 6.875 8.85001C7.025 8.71667 7.2 8.65001 7.4 8.65001C7.6 8.65001 7.775 8.71667 7.925 8.85001L12 12.925L16.1 8.85001C16.2333 8.70001 16.4 8.62901 16.6 8.63701C16.8 8.64567 16.975 8.71667 17.125 8.85001C17.275 9.00001 17.35 9.17901 17.35 9.38701C17.35 9.59567 17.275 9.76667 17.125 9.90001L12.625 14.4C12.5417 14.5 12.446 14.5667 12.338 14.6C12.2293 14.6333 12.1167 14.65 12 14.65Z",
    fill: "#2732D4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDownwardArrow);
export default __webpack_public_path__ + "static/media/blue-downward-arrow.97f8bcd969ac58d58c9380f57cdf36f8.svg";
export { ForwardRef as ReactComponent };